module.exports = __webpack_public_path__ + "static/img/AN_H5.5c3cabb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AN_H5.png
// module id = KjtH
// module chunks = 34